import { getActiveSocialNetworkFilters } from './socialNetworkFilter';

type BuildPublicationListSearchParamsArgs = Readonly<{
    searchText: string;
    searchStatus: string;
    searchNetwork: Readonly<Record<string, boolean>>;
    dateStart: string;
    dateEnd: string;
    dateOrder: Readonly<{ field: string; value: string }>;
}>;

const PUBLICATION_LIST_REFERER = 'page-publication';

const ACTIVE_STATUS_VALUES = new Set(['1', '2', '-1']);

function withReferer(params: URLSearchParams): string {
    params.set('referer', PUBLICATION_LIST_REFERER);
    return `?${params.toString()}`;
}

export function buildPublicationListSearchParams({
    searchText,
    searchStatus,
    searchNetwork,
    dateStart,
    dateEnd,
    dateOrder,
}: BuildPublicationListSearchParamsArgs): string {
    const params = new URLSearchParams();

    if (searchText.length >= 3) {
        params.set('title', searchText);
    }

    if (ACTIVE_STATUS_VALUES.has(searchStatus)) {
        params.set('status', searchStatus);
    }

    const activeNetworks = getActiveSocialNetworkFilters(searchNetwork);
    if (activeNetworks.length === 1) {
        params.set('social', activeNetworks[0]);
    }

    const { field, value } = dateOrder;
    if (field && value && dateStart && dateEnd) {
        params.set('fromDate', dateStart);
        params.set('toDate', dateEnd);
        params.set('order', value);
    } else if (field && value) {
        params.set(field, value);
    } else if (dateStart && dateEnd) {
        params.set('fromDate', dateStart);
        params.set('toDate', dateEnd);
    }

    return withReferer(params);
}
